import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'radio-buttons-component',
  templateUrl: './radio-buttons.component.html',
  styleUrls: ['./radio-buttons.component.scss'],
})
export class RadioButtonsComponent {
  @Input() public options: Array<any>;
  @Input() public selectedOption: number;
  @Input() public inline: boolean;
  @Output() public onChange: EventEmitter<number>;

  constructor(public sharedService: SharedService) {
    this.options = [];
    this.selectedOption = 0;
    this.inline = true;
    this.onChange = new EventEmitter<number>();
  }

  onClick(value) {
    if (this.selectedOption !== value) {
      this.selectedOption = value;
      this.onChange.emit(this.selectedOption);
    }
  }
}
